// eslint-disable-next-line no-restricted-imports
import CardActionArea from '@mui/material/CardActionArea';
import { useState } from 'react';
import { Grid } from 'src/components/Grid';
import { Stack } from 'src/components/Stack';
import { Typography } from 'src/components/Typography';
import { useCollectionTags } from 'src/models/pos-configuration/useCollectionTags';
import { resolveCollectionTagName } from 'src/models/pos-configuration/utils';
import { Identifier } from 'src/types/utilityTypes';
import { pluralize, titleize } from 'src/utils/stringFormatter';

import { usePosContext } from '../PosContext';

import FinderCardDialog from './FinderCardDialog';

interface PosProductCardProps {
  itemType: string;
  itemId: Identifier;
  title: string;
  description: string;
}

export default function PosProductFinderCard({
  itemId,
  itemType,
  title,
  description,
}: PosProductCardProps) {
  const [open, setOpen] = useState(false);
  const { getItemConfig, getItems } = usePosContext();
  const collectionTags = useCollectionTags();
  const itemConfig = getItemConfig(itemId);
  const tagName = itemConfig?.filterParams
    ? resolveCollectionTagName(itemConfig, collectionTags)
    : '';

  const items = getItems(itemType || '', tagName);

  return (
    <Grid
      key={`${itemId}`}
      size={{ xs: 12, sm: 6, md: 4, lg: 4, xl: 3 }}
      height="100px"
    >
      <CardActionArea
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          justifyContent: 'space-between',
          p: 2,
          minHeight: '100px',
          bgcolor: 'background.level2',
          borderRadius: 2,
          cursor: 'pointer',
          transition: 'background-color 0.3s ease',
          overflow: 'hidden',
          width: '100%',
          '&:hover': {
            bgcolor: 'background.level3',
            transition: 'background-color 0.3s ease',
          },
        }}
        onClick={() => setOpen(true)}
      >
        <Stack sx={{ width: '100%', minWidth: 0 }}>
          <Typography
            color="text.primary"
            variant="h6"
            sx={{
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
          >
            {titleize(title)}
          </Typography>
          <Typography color="text.secondary" variant="body2">
            {pluralize(itemConfig?.itemType || '', items?.length ?? 0)}
          </Typography>
        </Stack>
      </CardActionArea>

      <FinderCardDialog
        open={open}
        onClose={() => setOpen(false)}
        title={title}
        description={description}
        items={items ?? []}
        itemType={itemType || ''}
      />
    </Grid>
  );
}
